import React, { useContext } from 'react';

import { ReactComponent as SaveCollection} from "static/icons/save-collection.svg";

import UniversalButton from "../uiComponents/UniversalButton";
import SaveCollectionModal from "../modals/SaveCollectionModal";
import {ModalContext} from "../ModalContext";

const SaveAsCollection = ({tableInfo}) => {

  const { handleModal } = useContext(ModalContext);

  const openModal = () => {
    handleModal(
      <SaveCollectionModal closeCollectionModal={closeModal} tableInfo={tableInfo} selected={true}/>
    );
  }

  const closeModal = () => {
    handleModal(null, true);
  }

  return (
    <>
      <UniversalButton
        style={{height: '32px'}}
        label="Save as selection set"
        size="md"
        labelColor="blue"
        labelHoverColor="blue"
        backgroundColor="blue"
        backgroundHoverColor="$blue"
        leftIcon={<SaveCollection />}
        onClick={openModal}
        isRounded="sm"
      />
    </>
  );
};

export default SaveAsCollection;